module.exports = __webpack_public_path__ + "static/media/book-theater.d5fccf33.png";